import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import tw, { styled } from "twin.macro";
import { Loading, PageLoading } from "..";
import plus from "../../assets/svg/plus.svg";
import delFilled from "../../assets/svg/del_filled.png";
import { Button, Image, Input, message, Popconfirm, Upload } from "antd";
import {
	AppButton,
	btnStyle,
	hideScrollbar,
	inputStyle,
	SelectedBtnStyle,
} from "../../lib/styles/styleLibrary";
import { isEmpty, Toast } from "../../lib/helpers/helpers";
import {
	createShopItem,
	deleteShopImage,
	editShopItem,
} from "../../redux/actions/shop";
import cart from "../../assets/images/cart.png";
import API_MAP from "../../services/uri";
import axios from "axios";
import Currency from "../Currency/Currency";
import { useMutation } from "react-query";

const NewItemWrapper = styled.div`
	${tw`p-0.5 md:p-8 pt-4 h-full bg-white w-full flex flex-col container overflow-y-scroll`}
	height: 80vh;
	box-shadow: 0px 30px 60px rgba(32, 56, 85, 0.05);
	border-radius: 10px;

	.ant-upload.ant-upload-select-picture-card {
		${btnStyle}
		${tw`h-24! py-4! bg-white! rounded-md! hover:(bg-gray-50! border border-appPink!)`}
		border: 1px solid #d9d9d9 !important;
	}
	@media (max-width: 1217px) {
		height: auto;
		${({ hide }) => hide && `display: none;`};
	}
`;

const Thumbnail = styled.div`
	${tw`flex items-center justify-center shadow-md`}
	min-width: 125px;
	min-height: 125px;
	max-width: 125px;
	max-height: 125px;
	border-radius: 10px;
	background-color: #ddd;
	${({ bg }) => bg && `background: url(${bg});`};
	background-size: cover !important;
	background-position: center !important;
	background-repeat: no-repeat !important;
`;

const NewShopItems = (props) => {
	const {
		weddingID,
		setVisible,
		isEdit,
		shopDetails,
		refetch = () => {
			return null;
		},
	} = props;
	const { TextArea } = Input;
	const [defaultFileList, setDefaultFileList] = useState([]);
	const [loading, setLoading] = useState(false);
	const [imageUrls, setImageUrls] = useState([]);
	const [selectedUrl, setSelectedUrl] = useState("");
	const [payOption, setPayOption] = useState("online");
	const [showupload, setShowUpload] = useState(true);
	const [newItem, setNewItem] = useState({
		itemId: "",
		name: "",
		price: "",
		quantity_provided: "",
		images: [],
		description: "",
		payment_option: payOption,
	});

	useEffect(() => {
		setNewItem({ ...newItem, images: imageUrls });
		// eslint-disable-next-line
	}, [imageUrls]);

	useEffect(() => {
		if (!isEdit) {
			return;
		}
		if (isEmpty(shopDetails)) {
			return;
		}

		let urls = [];

		shopDetails?.shop_item_images?.map((img) => {
			return urls.push(img.media_url);
		});

		setNewItem({
			...newItem,
			itemId: shopDetails?.id || "",
			name: shopDetails?.name || "",
			price: shopDetails?.price || "",
			quantity_provided:
				shopDetails?.quantity_provided > shopDetails?.quantity_sold
					? shopDetails?.quantity_provided -
					  shopDetails?.quantity_sold
					: "",
			images: urls || [],
			description: shopDetails?.description || "",
			payment_option: shopDetails?.payment_option || payOption,
		});
		setImageUrls(urls);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [shopDetails]);

	const handleFileChange = ({ fileList }) => {
		// Processing file Change, guaranteed that the user selected by one is only one
		setDefaultFileList(fileList);
	};

	const handleUpload = async (options) => {
		const { onSuccess, onError, file } = options;
		if (isEmpty(defaultFileList)) {
			message.warning("Please select the file you want to upload");
		}
		if (isEmpty(weddingID)) {
			Toast.fire({
				icon: "error",
				title: "Cant upload cover photo, wedding ID not found",
			});
		}
		setShowUpload(true);
		const formData = new FormData();
		const config = {
			headers: { "content-type": "multipart/form-data" },
		};
		formData.append("media", file);
		axios
			.post(
				`${API_MAP.UploadShopItemImage}?weddingId=${weddingID}`,
				formData,
				config
			)
			.then(({ data }) => {
				onSuccess("Ok");
				// console.log("upload server res: ", data);
				const { hasError } = data;
				if (hasError) {
					return Toast.fire({
						icon: "error",
						title: `Invalid Media Upload\n${data.errors.message}`,
					});

				}
				const { media_records } = data.data;
				imageUrls.push(media_records[0].media_url);
				setDefaultFileList([]);
				setShowUpload(false);
				// message.success(data.message);
			})
			.catch((err) => {
				console.log("Error: ", err);
				onError({ err });
			});
	};

	const handleSubmit = async () => {
		// console.log("The item", newItem);
		if (isEmpty(newItem.name.trim())) {
			Toast.fire({
				icon: "error",
				title: `Item name is required`,
			});
			return;
		}
		if (isEmpty(newItem.price.toString().trim())) {
			Toast.fire({
				icon: "error",
				title: `Item price is required`,
			});
			return;
		}
		if (isEmpty(newItem.quantity_provided.toString().trim())) {
			Toast.fire({
				icon: "error",
				title: `Item quantity is required`,
			});
			return;
		}
		if (isEmpty(newItem.images)) {
			Toast.fire({
				icon: "error",
				title: `Upload at least one item image to continue...`,
			});
			return;
		}

		setLoading(true);

		const credentials = { ...newItem };

		try {
			const res = isEdit
				? await editShopItem({ credentials })
				: await createShopItem(newItem);

			// console.log("create/edit res", res);
			const { hasError } = res;
			if (hasError) {
				return Toast.fire({
					icon: "error",
					title: res?.errors?.message,
				});
			}
			isEdit
				? Toast.fire({
						icon: "success",
						title: res?.message,
				  })
				: Toast.fire({
						icon: "success",
						title: "Shop item created successfully",
				  });
			setImageUrls([]);
			setNewItem({
				name: "",
				price: "",
				quantity_provided: "",
				images: [],
			});
			refetch();
			setVisible(false);
		} catch (error) {
			console.log("new shop item error", error);
		} finally {
			setLoading(false);
		}
	};

	const { mutateAsync: handleDeleteImage, isLoading: deleteImage } =
		useMutation(deleteShopImage);

	const handleDelImg = async (data) => {
		console.log("item id", data);
		try {
			const res = await handleDeleteImage(data);
			console.log("handle del img res", res);
		} catch (error) {
			console.log(error, "del img err");
		}
	};
	return (
		<>
			{(loading || deleteImage) && <PageLoading />}
			<NewItemWrapper hide={props.hideOnMobile} css={hideScrollbar}>
				<h3
					tw="font-semibold tracking-wider"
					style={{ fontSize: "15px" }}>
					{isEdit ? "Edit Product" : "Add New Product"}
				</h3>

				<div tw="mt-4">
					<Input
						placeholder="Product Name"
						type="text"
						css={inputStyle}
						value={newItem.name}
						onChange={(e) =>
							setNewItem({ ...newItem, name: e.target.value })
						}
						tw="w-full text-xs! px-3 py-6 rounded-md"
					/>
				</div>

				<div tw="flex flex-row flex-nowrap gap-4 w-full mt-4 mb-4">
					<Currency changeUserDefault={false} />

					<Input
						placeholder="Price"
						type="number"
						css={inputStyle}
						min={0}
						value={newItem.price}
						onChange={(e) =>
							setNewItem({
								...newItem,
								price: e.target.value,
							})
						}
						tw="w-full text-xs! px-3 py-6 rounded-md mb-0!"
					/>
				</div>
				<div tw="mt-4">
					<Input
						placeholder="Quantity"
						type="number"
						css={inputStyle}
						min={0}
						value={newItem.quantity_provided}
						onChange={(e) =>
							setNewItem({
								...newItem,
								quantity_provided: e.target.value,
							})
						}
						tw="w-full text-xs! rounded-md"
					/>
				</div>
				<div tw="mt-4">
					<TextArea
						placeholder="Description"
						autoSize={{ minRows: 6 }}
						tw="mb-4 text-xs p-3 rounded-lg"
						value={newItem.description}
						onChange={(e) =>
							setNewItem({
								...newItem,
								description: e.target.value,
							})
						}
					/>
				</div>

				{/* <div tw="h-full overflow-y-scroll mb-4"> */}
				<div tw="mb-4">
					<div tw="flex flex-row gap-3 mt-4 flex-wrap">
						{imageUrls?.map((url, i) => {
							// console.log(url);
							return (
								<Thumbnail
									bg={url || cart}
									key={i}
									onClick={() => setSelectedUrl(url)}>
									<Popconfirm
										placement="bottom"
										title={`Remove this image?`}
										onConfirm={async () => {
											handleDelImg(shopDetails.id);
											selectedUrl === url &&
												message.success(
													"Image removed"
												);
											return setImageUrls(
												imageUrls.filter((file) => {
													return url !== file;
												})
											);
										}}
										okText="Ok"
										cancelText="Back">
										<span
											className="delBg"
											tw="flex items-center justify-center hover:cursor-pointer">
											<Image
												preview={false}
												src={delFilled}
												alt=""
												width={14}
												height={15}
												tw="rounded-md"
											/>
										</span>
									</Popconfirm>
								</Thumbnail>
							);
						})}
					</div>
					<div tw="mt-4">
						<Upload
							defaultFileList={defaultFileList}
							accept="image/*"
							onChange={handleFileChange}
							customRequest={handleUpload}
							maxCount={1}
							showUploadList={showupload}>
							{imageUrls.length >= 10 ? null : (
								<Button
									size="large"
									className="btnStyle"
									tw="h-auto py-4 bg-white rounded flex flex-col items-center justify-between gap-2">
									<div tw="flex flex-col items-center justify-center gap-2">
										<Image
											preview={false}
											src={plus}
											alt=""
											width={25}
											height={25}
										/>
										<span tw="opacity-60 text-xs">
											Upload your image
										</span>
									</div>
								</Button>
							)}
						</Upload>
					</div>
				</div>

				<div tw="mt-4 flex flex-col">
					<h4>Choose Payment Option</h4>
					<div tw="mt-2 flex flex-row flex-wrap md:flex-nowrap gap-2 w-full">
						<SelectedBtnStyle
							tw="rounded-3xl text-xs h-10"
							selected={payOption === "online" && true}
							onClick={() => {
								setPayOption("online");
							}}>
							Online Payment
						</SelectedBtnStyle>
						<SelectedBtnStyle
							tw="rounded-3xl text-xs h-10 justify-center"
							// disabled
							selected={payOption === "delivery" && true}
							onClick={() => {
								// setPayOption("delivery");
								message.info(
									"This option is not available yet!"
								);
							}}>
							Pay on Delivery
						</SelectedBtnStyle>
					</div>
				</div>

				<div tw="mt-8 mb-8">
					<AppButton
						// css={btnStyle}
						tw="rounded-md"
						onClick={() => {
							handleSubmit();
						}}>
						{loading ? (
							<Loading />
						) : isEdit ? (
							"EDIT"
						) : (
							"Add product"
						)}
					</AppButton>
				</div>
			</NewItemWrapper>
		</>
	);
};

export default NewShopItems;
